import React from 'react';
import { Formik, Form } from 'formik';
import * as Styles from './styles';
import { InputFormik } from '../ui/InputFormik';
import { Button } from '../../test/components/ui';
import { validateEmail, validatePhone } from '../../utils/helpers';
import { BasicDatePickerFormik } from '../ui/BasicDatePickerFormik';
import moment from 'moment';

type OptionsType<T> = { [K in keyof T]?: T[K] };

export interface IFormValues {
  workPlace: string;
  email: string;
  phone: string;
  education: string;
  position: string;
  dateBirth: string;
}

interface Props {
  title: string;
  description: string;
  data: OptionsType<IFormValues>;
  handleSubmit: (values: IFormValues, callback: (success: boolean, message?: string) => void) => void;
}

export const FormCerteficate: React.FC<Props> = ({ title, data, description, handleSubmit }) => {
  const [error, setError] = React.useState('');

  return (
    <Styles.WrapMessage>
      <h3 style={{ display: 'block', textAlign: 'center' }}>{title}</h3>
      <p>{description}</p>
      <p>Будь ласка, надайте додаткову інформацію:</p>
      <Formik
        enableReinitialize={true}
        initialValues={{
          dateBirth: data.dateBirth || '',
          education: data.education || '',
          email: data.email || '',
          phone: data.phone ? data.phone.replace('+38', '').replaceAll(' ', '') : '',
          position: data.position || '',
          workPlace: data.workPlace || '',
        }}
        onSubmit={(values, formik) => {
          if (!moment(values.dateBirth).isValid()) {
            return formik.setErrors({ dateBirth: 'Неправильне значення' });
          }

          if (moment(values.dateBirth) > moment()) {
            return formik.setErrors({ dateBirth: 'Дата не може бути в майбутньому' });
          }

          if (moment().get('year') - moment(values.dateBirth).get('year') > 100) {
            return formik.setErrors({ dateBirth: 'Вам, скоріше за все, менше 100 років.\nУведіть коректну дату, будь ласка.' });
          }

          formik.setSubmitting(true);
          setError('');

          handleSubmit(values, (success, message) => {
            if (!success) {
              setError('Сталася помилка');
            }
            formik.setSubmitting(false);
          });
        }}
      >
        {(formik) => (
          <Form>
            <Styles.WrapForm>
              <BasicDatePickerFormik name="dateBirth" required label="Дата народження" />
              <InputFormik
                label="Електронна пошта"
                required
                maxLength={250}
                name="email"
                handleValidate={(value) => {
                  if (!validateEmail(value)) {
                    return 'Неправильне значення';
                  }
                }}
              />
              <InputFormik
                label="Мобільний телефон, без пробілів і +38"
                required
                maxLength={10}
                name="phone"
                handleValidate={(value) => {
                  if (!validatePhone(value)) {
                    return 'Неправильне значення';
                  }
                }}
              />
              <InputFormik label="Освіта" required maxLength={250} name="education" />
              <InputFormik label="Місце роботи" name="workPlace" required maxLength={250} />
              <InputFormik label="Займана посада" required maxLength={250} name="position" />

              {error ? <span style={{ color: 'red' }}>{error}</span> : null}

              <Button type="submit" title="Відправити" />
            </Styles.WrapForm>
          </Form>
        )}
      </Formik>
    </Styles.WrapMessage>
  );
};
